/*
 * @Description: 
 * @Author: cooky
 * @Date: 2021-03-02 16:48:42
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-02 16:48:58
 */
import Help from './Help.vue'

Help.install = (Vue) => {
  Vue.component(Help.name, Help)
}

export default Help
